module.exports = __webpack_public_path__ + "assets/img/img.ef89a3c0.png";